'use es6';

import * as Operators from 'customer-data-filters/filterQueryFormat/operator/Operators';
import * as PropertyTypes from 'customer-data-objects/property/PropertyTypes';
import { PAGE_VIEW } from './DSAssetFamilies/DSAssetFamilies';
import { isSafe } from '../utilities/maxSafeInteger';
import FilterOperatorErrorRecord from './FilterOperatorErrorRecord';
import FormattedMessage from 'I18n/components/FormattedMessage';
import MissingField from './MissingField';
import get from 'transmute/get';
import getIn from 'transmute/getIn';
import { isRegexTooLong, isValidRegex, isRegexGroupCountValid } from './operator/OperatorValidators';
import { isExternalOptionsEnum } from '../utilities/isExternalOptionsEnum';
import { jsx as _jsx } from "react/jsx-runtime";
const getInvalidUrlCharacterRegex = () => /[\s\t\r\n]+/g;
const protocolRegex = /^((http|https):\/\/)/;
const validateUrl = operator => {
  const url = operator.get('value');
  const [__protocol, domain] = protocolRegex.test(url) ? url.split('://') : [undefined, undefined];
  if (url && !protocolRegex.test(url)) {
    return FilterOperatorErrorRecord({
      error: true,
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFilters.FilterEditor.operatorErrors.urlProtocol"
      })
    });
  }
  if (!domain) {
    return FilterOperatorErrorRecord({
      error: true,
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFilters.FilterEditor.operatorErrors.valueRequired"
      })
    });
  }
  if (getInvalidUrlCharacterRegex().test(url)) {
    return FilterOperatorErrorRecord({
      error: true,
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFilters.FilterEditor.operatorErrors.invalidUrlCharacter"
      })
    });
  }
  return {
    error: false
  };
};
const validateMinOccurrences = operator => {
  const operatorValue = operator.get('value');
  return FilterOperatorErrorRecord({
    error: operatorValue <= 0,
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFilters.FilterEditor.operatorErrors.minOccurrences"
    }),
    opts: {
      isRefinement: true,
      preventDefault: true
    }
  });
};
const validateOperator = operator => {
  const field = get('field', operator);
  const operatorValue = operator.get('value');
  if (MissingField.isMissingField(field)) {
    return FilterOperatorErrorRecord({
      error: false
    });
  }
  if ([Operators.PageViewMatchRegex, Operators.PageViewNotMatchRegex].includes(operator.constructor)) {
    if (!isValidRegex(operatorValue)) {
      return FilterOperatorErrorRecord({
        error: true,
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFilters.FilterEditor.operatorErrors.regexInvalid"
        })
      });
    }
    if (isRegexTooLong(operatorValue)) {
      return FilterOperatorErrorRecord({
        error: true,
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFilters.FilterEditor.operatorErrors.regexTooLong"
        })
      });
    }
    if (!isRegexGroupCountValid(operatorValue)) {
      return FilterOperatorErrorRecord({
        error: true,
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFilters.FilterEditor.operatorErrors.regexTooManyGroups"
        })
      });
    }
  }
  const refinement = operator.get('refinement');
  if (refinement) {
    if (refinement instanceof Operators.Greater && getIn(['field', 'type'], refinement) === PropertyTypes.NUMBER) {
      return validateMinOccurrences(refinement);
    }
    if (getIn(['field', 'type'], operator) === PAGE_VIEW && refinement instanceof Operators.LessThanRolling && get('direction', refinement) === 'forward') {
      return FilterOperatorErrorRecord({
        error: true,
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFilters.FilterEditor.operatorErrors.forwardRollingInvalid"
        }),
        opts: {
          isRefinement: true,
          preventDefault: true
        }
      });
    }
  }
  if (operator instanceof Operators.PageViewEqual || operator instanceof Operators.PageViewNotEqual) {
    return validateUrl(operator);
  }
  const isNumberTreatedLikeEnum = isExternalOptionsEnum(field);
  if (getIn(['field', 'type'], operator) === PropertyTypes.NUMBER && !isNumberTreatedLikeEnum && !(operator instanceof Operators.UpdatedAfter) && !(operator instanceof Operators.UpdatedBefore)) {
    if (operatorValue && !isSafe(operatorValue)) {
      return FilterOperatorErrorRecord({
        error: true,
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFilters.FilterEditor.operatorErrors.largeNumberInvalid"
        })
      });
    }
  }
  return FilterOperatorErrorRecord({
    error: false
  });
};
export default validateOperator;